import { render, staticRenderFns } from "./TaofukeBrandList.vue?vue&type=template&id=1cfe6fcd&"
import script from "./TaofukeBrandList.vue?vue&type=script&lang=js&"
export * from "./TaofukeBrandList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports